/*import Vue from 'vue';
import Vuetify from 'vuetify/lib';
//import 'vuetify/src/stylus/app.styl';
//import 'vuetify/src/styles/main.sass'

import 'vuetify/dist/vuetify.min.css'


Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#4772d9',
    secondary: '#e91e63',
    accent: '#5885ef',
    error: '#f44336',
    warning: '#ffc107',
    info: '#607d8b',
    success: '#4caf50',
  },

});


 */
// v2.0
// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify/lib";
import { Touch } from "vuetify/lib/directives";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify, {
  directives: {
    Touch
  }
});

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    dark: false,
    themes: {
      dark: {
        primary: "#1976D2",
        accent: "#8B58D9",
        secondary: "#F141CC",
        success: "#4CAF50",
        info: "#54F1E3",
        warning: "#FFEB3B",
        error: "#BF360C"
      },
      light: {
        primary: "#1976D2",
        accent: "#8B58D9",
        secondary: "#E03CBD",
        success: "#4CAF50",
        info: "#54F1E3",
        warning: "#FFEB3B",
        error: "#BF360C"
      }
    }
  }
});

/*
theme: {
    primary: '#4772d9',
    secondary: '#e91e63',
    accent: '#5885ef',
    error: '#f44336',
    warning: '#ffc107',
    info: '#607d8b',
    success: '#4caf50',
  },*/
